export const DELETE_ASSET_REQUEST = 'gatewayManagement/DELETE_ASSET_REQUEST';
export const DELETE_ASSET = 'gatewayManagement/DELETE_ASSET';
export const CLEAR_STORE = 'gatewayManagement/DELETE_ASSET_CLEAR_STORE';
